import { createTheme } from '@mui/material/styles';

const theme = createTheme();
// Keep shared controls usable in narrow pages and dialogs.
theme.components = {
  MuiTypography: {
    styleOverrides: {
      root: { overflowWrap: 'anywhere' },
      h3: { [theme.breakpoints.down('sm')]: { fontSize: '2rem' } },
      h4: { [theme.breakpoints.down('sm')]: { fontSize: '1.65rem' } },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: { [theme.breakpoints.down('sm')]: { margin: 16, maxWidth: 'calc(100% - 32px)', maxHeight: 'calc(100% - 32px)' } },
      paperFullWidth: { [theme.breakpoints.down('sm')]: { width: 'calc(100% - 32px)' } },
    },
  },
  MuiDialogTitle: { styleOverrides: { root: { overflowWrap: 'anywhere', [theme.breakpoints.down('sm')]: { padding: 16 } } } },
  MuiDialogContent: { styleOverrides: { root: { minWidth: 0, [theme.breakpoints.down('sm')]: { padding: 16 } } } },
  MuiDialogActions: { styleOverrides: { root: { flexWrap: 'wrap', gap: 8 } } },
  MuiToggleButtonGroup: { styleOverrides: { root: { maxWidth: '100%', overflowX: 'auto', flexShrink: 0 } } },
  MuiToggleButton: { styleOverrides: { root: { flexShrink: 0 } } },
  MuiMenuItem: { styleOverrides: { root: { whiteSpace: 'normal', overflowWrap: 'anywhere' } } },
  MuiAlert: { styleOverrides: { message: { minWidth: 0, overflowWrap: 'anywhere' } } },
};
export default theme;
